import { render, staticRenderFns } from "./DeliveryPage.vue?vue&type=template&id=6b6080dc&scoped=true&"
import script from "./DeliveryPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryPage.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPage.vue?vue&type=style&index=0&id=6b6080dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6080dc",
  null
  
)

export default component.exports